import { newsletterSubmitSuccess } from "./analytics";

(function(window) {

  var trNewsletter = {
    // Get all careers search forms
    init: function() {

      const trNewsletterEl = document.getElementsByClassName('TrForm-newsletterEl');

      if (!trNewsletterEl.length) {
        return;
      }

      this.eachForm(trNewsletterEl);
    },

    // Loop through each form on page and run blur/submit functions if CORS is supported
    eachForm: function(forms) {
      for (let form of forms) {
        if ('withCredentials' in new XMLHttpRequest()) {
          // disable html5 validation
          form.noValidate = true;
          this.onSubmit(form);
          this.onBlur(form);
        } else {
          form.style.display = 'none';
        }
      };
    },

    // When user submits, get all required fields, test them and return values, if all values are true, submit form
    onSubmit: function(form) {
      const self = this;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const fields = form.querySelectorAll('[required]');
        const newsletter = form.dataset.newsletter;
        const allValidate = [];

        for (let field of fields) {
          const fieldVal = field.value ? field.value.trim() : '';
          // Test fields return values
          const isValid = self.testFields(field.type, fieldVal);

          // Push test values to array
          allValidate.push(isValid);
          // Show notices accordingly
          self.showNotice(field, isValid);
        };

        // Are all fields validated?
        function validateAll(i) {
          return i === true;
        }
        const ready = allValidate.every(validateAll);

        if (ready && newsletter) {
          self.newsletterApi(form, newsletter);
        }
      });
    },

    // Use newsletter api
    newsletterApi: function(form, newsletter) {

      // Form data as object using email and blogIds
      const formData = {
        "email": form.email.value,
        "blogIds": [
          form.dataset.blogid
        ]
      };

      // Fetch post data to api, test for errors
      fetch(newsletter, {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        })
      }).then(function(response) {
          if (!response.ok) {
            throw Error(response.statusText);
          } else {
            form.email.classList.remove('TrForm-newsletterInput--invalid');

            if (response.status !== 200) {
              console.log(response + 'ggg');
              form.email.classList.add('TrForm-newsletterInput--error');
            } else {
              form.email.classList.add('TrForm-newsletterInput--success');
              newsletterSubmitSuccess({ pathName: window.location.pathname });
            }

          }
      }).catch(function(error) {
        console.log(error);
        form.email.classList.remove('TrForm-newsletterInput--invalid');
        form.email.classList.add('TrForm-newsletterInput--error');
      });
    },


    // When user leaves a field, check if field is required, if so test and return value
    onBlur: function(form) {
      const self = this;
      form.addEventListener('blur', function(e) {
        const field = e.target;
        const required = field.hasAttribute('required');
        const fieldVal = field.value.trim();

        if (required && fieldVal !== '') {
          // Test fields return values
          const isValid = self.testFields(field.type, fieldVal);
          // Show notices accordingly
          self.showNotice(field, isValid);
        } else if(required && fieldVal == '') {
          field.classList.remove('TrForm-newsletterInput--invalid');
          field.classList.remove('TrForm-newsletterInput--error');
        }
      }, true);
    },

    // Test fields and return values function
    testFields: function(type, value) {
      if (type === 'email') {
        const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailPattern.test(value)) {
          return true;
        }
      }
    },

    // Hide or show notices function
    showNotice: function(field, isValid) {
      // Class to add or remove
      const validFalse = 'TrForm-newsletterInput--invalid';

      if (isValid) {
        field.classList.remove(validFalse);
      } else {
        field.classList.add(validFalse);
        field.classList.remove('TrForm-newsletterInput--error');
      }
    }

  };

  (function() {
    trNewsletter.init();
  })();

})(window);



// WEBPACK FOOTER //
// ./js/tr-newsletter-validation.js